module.exports = __webpack_public_path__ + "static/img/service.30a82b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service.png
// module id = M8mE
// module chunks = 1